import { render, staticRenderFns } from "./TechNews.vue?vue&type=template&id=59f9a26d&scoped=true"
import script from "./TechNews.vue?vue&type=script&lang=js"
export * from "./TechNews.vue?vue&type=script&lang=js"
import style0 from "./TechNews.vue?vue&type=style&index=0&id=59f9a26d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f9a26d",
  null
  
)

export default component.exports